import useScheduleDelivery from '../../../hooks/scheduleDelivery/useScheduleDelivery';
import {
  ScheduleDeliveryDataType,
  scheduleDeliveryInitialValues,
  ScheduleDeliverySchema,
} from '../../../models/scheduleDelivery/scheduleDelivery';
import { FormSubmitButton } from '../../Button/FormSubmitButton';
import { CustomDropDownDatePicker } from '../../FormCom/CustomDropDownDatePicker';
import { FormComponent } from '../../FormCom/FormComponent';
import ModalContainer from '../ModalContainer';

interface ScheduleDeliveryModalProps {
  data?: any;
}
const ScheduleDeliveryModal = ({ data }: ScheduleDeliveryModalProps) => {
  const { scheduleDelivery, loading } = useScheduleDelivery();

  const handleOnSubmit = (values: ScheduleDeliveryDataType) => {
    scheduleDelivery({ ...values, id: data?.id || '' });
  };

  return (
    <ModalContainer
      label='Re-Schedule Delivery Date'
      description='Choose a preferred delivery date'
    >
      <FormComponent
        initialValues={scheduleDeliveryInitialValues}
        schema={ScheduleDeliverySchema}
        onSubmit={handleOnSubmit}
      >
        <CustomDropDownDatePicker
          label='Date'
          name='scheduledDate'
          id='scheduledDate'
          placeholder=''
        />

        <FormSubmitButton loading={loading}>Submit</FormSubmitButton>
      </FormComponent>
    </ModalContainer>
  );
};

export default ScheduleDeliveryModal;
